import { useMemo } from "react";
import { GroupCategoryResponse } from "../../api/gms/group-category/group-category-api-state";
import { PROPOSAL_AS_IDS } from "../../constant/gms-constant";

interface Props {
    defaultProposalAs: { id: number; name: string; };
    statusProposalType: GroupCategoryResponse[] | undefined;
    selectedProposalTypeId: number | undefined;
    isRenewal: boolean;
}

export const useProposalTypeDataUseMemo = ({ defaultProposalAs, statusProposalType, selectedProposalTypeId, isRenewal }: Props) => {

    const proposalTypeOptions = useMemo(() => {
        const options = [
            defaultProposalAs,
            ...(statusProposalType?.map((item) => ({
                id: item.id,
                name: item.name,
            })) || [])
        ];

        return options.filter((item) => {
            if (!isRenewal && item.id === PROPOSAL_AS_IDS.renew) return false;
            if (isRenewal && item.id === PROPOSAL_AS_IDS.new) return false;

            return true;
        });
    }, [defaultProposalAs, statusProposalType, isRenewal]);


    const proposalTypeValue = useMemo(() => {
        return ( proposalTypeOptions.find(opt => opt.id === selectedProposalTypeId) || defaultProposalAs );
    }, [selectedProposalTypeId, proposalTypeOptions, defaultProposalAs]);

    return {
        proposalTypeOptions,
        proposalTypeValue
    }
}